/**
 * API Configuration
 * 
 * This file centralizes all API and image URL configurations.
 * 
 * To configure for different environments:
 * 1. Create a .env file in the root directory
 * 2. Add: REACT_APP_API_BASE_URL=http://your-api-url:port
 * 3. Restart the development server
 * 
 * Example .env file:
 *   REACT_APP_API_BASE_URL=http://localhost:8084
 * 
 * For production builds, set the environment variable before building:
 *   REACT_APP_API_BASE_URL=https://hrmsapi.ampcustech.com npm run build
 */

const API_CONFIG = {
  
  // Base URL for API calls (without /api suffix)
  // Can be overridden via REACT_APP_API_BASE_URL environment variable
  BASE_URL: process.env.NODE_ENV =="development"? "http://localhost:8084": "https://hrmsuatapi.acquaa.org",
  
  // API endpoint prefix
  API_PREFIX: "/api",
  
  /**
   * Full API base URL for axios requests
   * Returns: BASE_URL + API_PREFIX (e.g., "http://localhost:8084/api")
   */
  get API_BASE_URL() {
    return `${this.BASE_URL}${this.API_PREFIX}`;
  },
  
  /**
   * Base URL for static files and images
   * Returns: BASE_URL (e.g., "http://localhost:8084")
   */
  get IMAGE_BASE_URL() {
    return this.BASE_URL;
  },
  
  /**
   * Helper function to get full image URL
   * @param {string} imagePath - Relative or absolute image path
   * @returns {string|null} - Full image URL or null if imagePath is empty
   * 
   * Examples:
   *   getImageUrl("/uploads/profile-images/user.jpg") 
   *     => "http://localhost:8084/uploads/profile-images/user.jpg"
   *   getImageUrl("http://example.com/image.jpg") 
   *     => "http://example.com/image.jpg" (returns as is)
   */
  getImageUrl: (imagePath) => {
    if (!imagePath) return null;
    // If imagePath already includes http/https, return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    // Otherwise, prepend the base URL
    return `${API_CONFIG.IMAGE_BASE_URL}${imagePath}`;
  }
};

export default API_CONFIG;
